import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DashboardSidebar from './DashboardSidebar';
import InfoEventsSidebar from './InfoEventsSidebar';
import RidesSidebar from './RidesSidebar';

class Sidebar extends Component {
  render() {
    return this.props.pathname === '/messages' ?
      <InfoEventsSidebar /> : this.props.pathname === '/rides' ?
        <RidesSidebar /> : <DashboardSidebar />;
  }
}

Sidebar.propTypes = {
  pathname: PropTypes.string,
};

export default connect(
  state => ({
    pathname: state.routing.locationBeforeTransitions.pathname,
  }),
  () => ({}),
)(Sidebar);



// WEBPACK FOOTER //
// ./src/components/Sidebar/index.js